import { useState, useEffect } from "react";
import { kvImages } from "@/mocks/news";

const HeroSection = () => {
  const [currentImg, setCurrentImg] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImg((prev) => (prev + 1) % kvImages.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative w-full h-screen min-h-[600px] overflow-hidden">
      {kvImages.map((src, i) => (
        <div
          key={src}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            i === currentImg ? "opacity-100" : "opacity-0"
          }`}
        >
          <img src={src} alt="" className="w-full h-full object-cover object-top" />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/40" />

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-8 z-10">
        <div className="border border-white/70 text-white text-xs font-semibold px-4 py-2 rounded-full tracking-widest">
          Scroll
        </div>
      </div>

      {/* Dots */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex gap-2">
        {kvImages.map((_, i) => (
          <button
            key={i}
            type="button"
            onClick={() => setCurrentImg(i)}
            className={`h-2 rounded-full transition-all cursor-pointer ${
              i === currentImg ? "bg-white w-6" : "bg-white/50 w-2"
            }`}
            aria-label={`画像 ${i + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default HeroSection;
